import { Button } from 'primereact/button';
import { FC } from 'react';

const ActionButtonsTemplate: FC<PropTypes> = ({
  disabled,
  rowData,
  onEdit,
  onRemove,
}) => (
  <div className="flex justify-content-center">
    <Button
      className="mr-2 button-primary"
      type="button"
      onClick={() => onEdit(rowData)}
      icon="pi pi-pencil"
      disabled={disabled}
    />
    <Button
      className="button-danger"
      type="button"
      onClick={() => onRemove(rowData.identification)}
      icon="pi pi-trash"
      disabled={disabled}
    />
  </div>
);

type PropTypes = {
  disabled: boolean;
  rowData: any;
  onEdit: (rowData: any) => void;
  onRemove: (identification: string | null) => void;
};

export default ActionButtonsTemplate;
